import React from 'react';
import clsx from 'clsx';
import { useSanitize } from '../../hooks/useSanitize';
import * as Styled from './ASubheader.styles';
import { ASubheaderTag, ASubheaderSize, type ASubheaderProps } from './ASubheader.types';

const COMPONENT_NAME = 'a-web-ui-kit-ASubheader';
const TEST_ID = 'web-ui-kit-ASubheader';

const ASubheaderAllowedTags = ['sub', 'sup', 'br', 'span'];
const sanitizeOpts = { ALLOWED_TAGS: ASubheaderAllowedTags };

function ASubheader({
  text,
  size = ASubheaderSize.L,
  element = ASubheaderTag.h2,
  className,
  ...rest
}: ASubheaderProps) {
  const mergedClassName = clsx(className, `t-subtitle-${size.toLowerCase()}`);
  const Tag = element;

  const { isDangerouslySet, result: cleanText } = useSanitize(text, sanitizeOpts);

  return isDangerouslySet ? (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      as={Tag}
      className={mergedClassName}
      {...rest}
      dangerouslySetInnerHTML={{ __html: cleanText }}
    />
  ) : (
    <Styled.Wrapper
      data-component-name={COMPONENT_NAME}
      data-testid={TEST_ID}
      as={Tag}
      className={mergedClassName}
      {...rest}
    >
      {cleanText}
    </Styled.Wrapper>
  );
}

export { ASubheader, ASubheaderSize, ASubheaderTag, TEST_ID as A_SUBHEADER_TEST_ID };
